import React from 'react';
interface ServiceCardProps {
  title: string;
  description: string[];
}
export const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  description
}) => {
  return <div className="bg-white px-8 py-10 sm:px-10 sm:py-12 flex flex-col text-center hover:translate-y-[-2px] transition-transform" data-id="element-157">
      <h3 className="text-2xl sm:text-3xl font-sans text-[#486878] mb-5 sm:mb-6 font-medium" data-id="element-158">
        {title}
      </h3>
      <div className="text-[#486878] space-y-4 sm:space-y-5 text-base sm:text-lg leading-relaxed" data-id="element-159">
        {description.map((paragraph, index) => <p key={index} data-id="element-160">{paragraph}</p>)}
      </div>
    </div>;
};